"use client";

import { useState } from "react";

export function HeroBackdrop() {
  const [desktopOk, setDesktopOk] = useState(true);
  const [mobileOk, setMobileOk] = useState(true);

  return (
    <>
      {desktopOk && (
        // eslint-disable-next-line @next/next/no-img-element
        <img
          src="/bg/desktop.jpg"
          alt=""
          aria-hidden
          loading="eager"
          fetchPriority="high"
          className="absolute inset-0 hidden h-full w-full object-cover sm:block"
          onError={() => setDesktopOk(false)}
        />
      )}
      {mobileOk && (
        // eslint-disable-next-line @next/next/no-img-element
        <img
          src="/bg/mobile.jpg"
          alt=""
          aria-hidden
          loading="eager"
          fetchPriority="high"
          className="absolute inset-0 block h-full w-full object-cover sm:hidden"
          onError={() => setMobileOk(false)}
        />
      )}
      <div
        aria-hidden
        className="absolute inset-0 bg-gradient-to-b from-night-950/85 via-night-950/15 to-night-950/90"
      />
    </>
  );
}
